import { render, staticRenderFns } from "./OrderNowMap.vue?vue&type=template&id=13b96ea0&scoped=true&"
import script from "./OrderNowMap.vue?vue&type=script&lang=js&"
export * from "./OrderNowMap.vue?vue&type=script&lang=js&"
import style0 from "./OrderNowMap.vue?vue&type=style&index=0&id=13b96ea0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b96ea0",
  null
  
)

export default component.exports